import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { toDateFormatComma } from '~/shared/utils/date'
import { toCroppedImage } from '~/shared/utils/image'

export default class ResearchShowcaseCard extends BaseModel {
  static override constructorName = 'ResearchShowcaseCard'

  id: number = 0
  name: string = ''
  slug: string = ''
  url: string = ''
  'preview_image': string = ''
  description: string = ''
  'author_name': string = ''
  direction: string = ''
  university: string = ''
  'date_publication': string = ''
  'likes_count': number = 0
  'views_count': number = 0

  constructor(data?: unknown) {
    super(data)
    if (!isUnknownObject(data)) return

    fillOwnProperties(this, data)

    this.preview_image = toCroppedImage(this.preview_image)

    if (this.date_publication) {
      this.date_publication = toDateFormatComma(this.date_publication)
    }
  }
}

registerModel(ResearchShowcaseCard)
